import RoleTreeSelect from './RoleTreeSelect'

export default RoleTreeSelect
